// test2596
(2596 && 0);
